import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackIntegrationCardClicked.meta';

export type UseTrackIntegrationCardClickedParams = {
  integration_id: string;
  integration_name: string;
  integration_section: string;
  integration_status: string;
};

export const useTrackIntegrationCardClicked = () => {
  const { track } = useAnalyticsUtilities();

  const trackIntegrationCardClicked = useCallback(
    (params: UseTrackIntegrationCardClickedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackIntegrationCardClicked };
};
